import type { ValueOf } from 'type-fest';
import type { DynamicImage } from '../dynamic-image/dynamic-image.types';

export const themes = {
  primary: 'Primary',
  secondary: 'Secondary',
  featured: 'Featured',
} as const;

export const variants = {
  imageLeft: 'imageLeft',
  imageRight: 'imageRight',
  centerAlignContent: 'centerAlignContent',
} as const;

export type Quote = {
  additionalInfo?: string;
  background: 'dark' | 'light';
  focusable?: boolean;
  image?: DynamicImage;
  signature: string;
  tall?: boolean;
  theme?: ValueOf<typeof themes>;
  variant?: ValueOf<typeof variants>;
  quote: string;
  quoteTextWeightBold?: boolean;
};
